<template>

    <div class="container__body container__body--sm">

        <header class="col-12 padding-b-25 margin-b-25 border-b flex--space">

            <h1>Anretning</h1>

        </header>

        <section class="col-12 margin-b-100">

            <template v-if="option.wiki_link_title">

                <section class="guide">

                    <section class="content">

                        <h1>{{option.wiki_link_title}}</h1>
                        <h3 v-if="String(option.wiki_link_description).length > 0" v-html="option.wiki_link_description"></h3>
                        <ul class="relations">
                            <li>{{option.wiki_link_product}} -> {{option.wiki_link_category}}</li>
                        </ul>

                    </section>

                    <section class="link">

                        <a href="#" @click.prevent="showDeleteModal = true" v-if="option.wiki_link_id !== null" v-cloak>Fjern</a>

                    </section>

                </section>

            </template>

            <section class="col-12 feedback feedback__info" v-else>

                <h3>Der er ikke tilføjet en anretning</h3>

                <p><a href="#" class="" @click.prevent="showRecipeModal = true">Klik her</a> for at tilføje guide til anretning til denne ret.</p>

            </section>

        </section>

        <header class="col-12 margin-tb-25 padding-b-25 border-b flex--space">

            <h1>Pakkeliste</h1>
            <router-link :to="{name:'option.edit.packaging.create'}">Tilføj ny</router-link>

        </header>

        <section class="data-list" v-if="items && items.length > 0">

            <transition-group name="fade" tag="div">

                <div class="item" v-for="item in items" :key="item.id">

                    <div class="icon">

                        <i class="icon--md fas fa-tag"></i>

                    </div>

                    <div class="content">

                        <h1 v-text="item.title"></h1>

                    </div>

                    <div class="link">

                        <router-link :to="{name:'option.edit.packaging.edit', params:{item:item.id}}">Administrer</router-link>

                    </div>

                </div>

            </transition-group>

        </section>

        <section class="col-12 center" v-else>

            <p class="margin-t-100">Ingenting tilføjet</p>

        </section>

        <section class="col-12 margin-t-75">

            <router-link :to="{name:'option.index'}" class="btn btn--md btn--primary primary--copper">Gem & afslut</router-link>

        </section>

        <ws-modal v-model="showRecipeModal">

            <div class="modal-wrap">

                <div class="modal--sm center">

                    <span class="close" @click.prevent="showRecipeModal = false"><i class="fas fa-times"></i></span>

                    <section v-if="recipeItems">

                        <section class="col-12 margin-b-150">

                            <form class="col-12">

                                <label>Søg efter anretning</label>

                                <section class="search">

                                    <VueFuse
                                        class="col-12"
                                        :list="recipeItems"
                                        :default-all="true"
                                        placeholder="Hvad er navnet på anretningen?"
                                        :fuse-opts="searchOptions"
                                        :map-results="true"
                                        @fuse-results="handleResults">
                                    </VueFuse>

                                </section>

                            </form>

                        </section>

                        <section class="data-list left">

                            <header class="col-12 margin-b-50">

                                <h1>Oversigt</h1>

                            </header>

                            <transition-group name="fade" mode="out-in">

                                <section class="item" v-for="recipe in results" :key="recipe.id">

                                    <section class="icon">

                                        <i class="icon--lg fas fa-shopping-bag"></i>

                                    </section>

                                    <section class="content">

                                        <h1 v-text="recipe.title"></h1>

                                        <h3 v-html="recipe.description"></h3>

                                        <ul class="products">
                                            <li v-for="cat in recipe.category">{{ cat.product.title }} -  {{cat.title}}</li>
                                        </ul>


                                    </section>

                                    <section class="link">

                                        <a href="#" @click.prevent="updateRecipeWikiLink(recipe)">Anvend</a>

                                    </section>

                                </section>

                            </transition-group>

                        </section>

                    </section>

                </div>

            </div>

        </ws-modal>

        <ws-modal v-model="showDeleteModal">

            <div class="modal-wrap">

                <div class="modal--sm center">

                    <span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

                    <i class="fas fa-trash-alt icon--lg margin-b-25"></i>

                    <h1>Slet</h1>

                    <h2>Er du sikker på du vil fjerne anretningen {{option.wiki_link_title}}?</h2>

                    <h3>Du kan ikke fortryde denne handling!</h3>

                    <div class="col-12 margin-t-25">

                        <a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteRecipeWikiLink">Ja tak</a>

                        <a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

                    </div>

                </div>

            </div>

        </ws-modal>

    </div>
</template>

<script>
import {mapGetters} from "vuex";
import VueFuse from 'vue-fuse';
export default {
    name: "index",
    components:{
        VueFuse,
    },
    data(){
        return {
            items:[],
            recipeItems:[],
            showRecipeModal: false,
            showDeleteModal: false,
            searchOptions: {
                keys:['title']
            },
            results:[],
            option:{},
        }
    },
    methods:{
        getOption(){
            axios.get(`/api/admin/option/${this.$route.params.option}`).then(response => {
                response.data.data.image_name = '';
                this.option = response.data.data;
            });
        },
        getPackagingItems(){
            axios.get(`/api/admin/option/${this.$route.params.option}/packaging`).then((response) => {
                this.items = response.data.data;
            })
        },
        getWikiOptions(){
            const domain = window.configExport.wiki_link_url;

            axios.get(`${domain}/api/v1/recipes`).then(response => {
                this.recipeItems = response.data.data;
            });
        },
        updateRecipeWikiLink(recipe){
            if(!recipe) return;

            this.showRecipeModal = false;

            axios.put(`/api/admin/option/${this.$route.params.option}/wiki`, {
                wiki_link_id: recipe.id,
                wiki_link_title: recipe.title,
                wiki_link_product: recipe.category.length > 0 ? recipe.category[0].product.title : null,
                wiki_link_category: recipe.category.length > 0 ? recipe.category[0].title : null,
                wiki_link_description: recipe.description,
            }).then((response) => {
                this.getOption();
            })

            console.log(recipe)

        },
        deleteRecipeWikiLink(){
            axios.delete(`/api/admin/option/${this.$route.params.option}/wiki`).then((response) => {
                this.getOption();
                this.showDeleteModal = false;
            })
        },
        handleResults (r) {
            this.results = r
        },

    },
    created(){
        this.getOption();
        this.getPackagingItems();
        this.getWikiOptions();
    }
}
</script>

<style scoped>

</style>
